/* eslint css-modules/no-unused-class: [2, { markAsUsed: ['boxInfoMsg', 'blockMsg', 'blockInfoMsg', 'blockErrorMsg'] }] */
import React from 'react';

import { MIXED_RETURN_DESTINATION_ERROR } from 'middleware/fetchErrorMiddleware';
import {
  RETURN_REASON_MISSING_ACCEPT_TERMS_OF_RETURN_ERROR,
  RETURN_REASON_REQUIRES_CUSTOMER_SERVICE_ERROR,
  RETURN_REASONS_HAVE_NOT_BEEN_SELECTED_ERROR
} from 'constants/returnReasons';
import { AriaLiveTee } from 'components/common/AriaLive';

import css from 'styles/containers/returns/returnsMessages.scss';

const ReturnErrorMessage = ({ phoneNumber, isReturnError, returnErrorType, mixedReturnMessage = '' }) => {
  if (!isReturnError) {
    return null;
  }

  const message = getMessageForErrorType(returnErrorType, mixedReturnMessage, phoneNumber);

  return (
    <div className={css.boxErrorMsg}>
      <AriaLiveTee>{message}</AriaLiveTee>
    </div>
  );
};

const getMessageForErrorType = (returnErrorType, mixedReturnMessage, phoneNumber) => {
  switch (returnErrorType) {
    case MIXED_RETURN_DESTINATION_ERROR:
      return <>{mixedReturnMessage}</>;

    case RETURN_REASONS_HAVE_NOT_BEEN_SELECTED_ERROR:
      return <>Oops! Please select the return reason for each item you are returning. Your answers will help us improve the returns experience.</>;

    case RETURN_REASON_REQUIRES_CUSTOMER_SERVICE_ERROR:
      return (
        <>
          <strong>An item needs extra help to return.</strong> For help with your return, please contact{' '}
          <a href="https://www.zappos.com/c/contact-us">customer service</a>.
        </>
      );
    case RETURN_REASON_MISSING_ACCEPT_TERMS_OF_RETURN_ERROR:
      return <>Please agree to the terms before proceeding.</>;
    case null:
    default:
      return (
        <>
          We apologize. Something went wrong on our end. Please call customer service at <strong>{phoneNumber}</strong> if you would like to continue
          with this return.
        </>
      );
  }
};

export default ReturnErrorMessage;
